import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ShieldCheck } from 'lucide-react';

export const Route = createFileRoute('/admin-console/platform-content/obligations/controls-library')({
    staticData: {
        breadcrumb: {
            title: 'Controls library',
        },
        ui: {
            icon: ShieldCheck,
            menuDescription: 'Master controls library',
        },
    },
    component: Outlet,
});
